import React from "react";
import { connect } from "react-redux";
import Moment from "moment";

import { postData, putData, showToast } from "Source/globalFunction";

import Date from "./Input/Date/Date";
import Name from "./Input/Name/Name";

const defaults = {
    holidays: [
        {date: null, holiday: null},
        {date: null, holiday: null},
        {date: null, holiday: null}
    ]
}

@connect(store => {
    return {
        projectSettings: store.projectSettings
    };
})

class Form extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { dispatch, holidays, view=false } = this.props;

        /**
         * Adding of rows in table
         */
        const handleAdd = () => {
            dispatch({ type: "UPDATE_SETTINGS_ADD_HOLIDAYS", holiday: {date: null, holiday: null}})
        }
       const projectHoliday = view? holidays.filter(h=>h.date):holidays
        return (
            <div class="formBody">
                <div class="formContainer">
                    <label>Add Holidays</label>
                    <div class={`${!view? "formTable": "formTableView"}`}>
                        <table>
                            <thead>
                                <tr>
                                    <td>#</td>
                                    <td>Date</td>
                                    <td>Holiday Name</td>
                                </tr>
                            </thead>
                            <tbody>
                                {projectHoliday.map((h, i) => {
                                    const handleChangeDate = (date) => {
                                        let error = false
                                        if(!date && projectHoliday[i].holiday) {
                                            error = true
                                        }
                                        dispatch({ type: "UPDATE_SETTINGS_HOLIDAY", index: i, holiday: {date:  date === 'Invalid date'?null: date,error } });
                                    }

                                    const handleChangeHoliday = (e) => {
                                        if(e.target.value.length && !projectHoliday[i].date) {
                                            dispatch({ type: "UPDATE_SETTINGS_HOLIDAY", index: i, holiday: {holiday: e.target.value, error:true }});
                                        } else {
                                            dispatch({ type: "UPDATE_SETTINGS_HOLIDAY", index: i, holiday: {holiday: e.target.value, error:false} });
                                        }
                                    
                                        
                                    }
                                     if (view) {
                                        return (
                                            <tr>
                                                <td>{i + 1}</td>
                                                <td>{h.date}</td>
                                                <td>{h.holiday?h.holiday:'--'}</td>
                                            </tr>
                                        )
                                     } else {
                                         const hasError = h.error
                                        return (
                                            <tr>
                                                <td>{i + 1}</td>
                                                <td><Date id={`date_${i}`} value={h.date} onChange={handleChangeDate}/></td>
                                                <td>
                                                    <div class="holidayNameContainer">
                                                        <input type="text" onChange={handleChangeHoliday} placeholder="Holiday Name" value={h.holiday} />
                                                        { hasError && <span class="errorMsg">Please add a holiday Date <i class="material-icons ml10">info</i></span>}
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                     }
                                   
                                })}
                            </tbody>
                        </table>
                    </div>
                    {!view &&
                    <div class="formAction">
                        <a onClick={handleAdd}>
                            <i class="material-icons addCalendar">add</i>
                            <span>Add Row</span>
                        </a>
                    </div>}
                </div>
            </div>
        );
    }
}

Form.defaultProps = {
    callbacks: {},
    calendar: {
        calendar_holiday: []
    }
};

export default Form;